// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__vdP0k","fade-in":"Spinner_fade-in__oWp4S","svg-wrapper":"Spinner_svg-wrapper__ZG__8","spin-in":"Spinner_spin-in__tsR1W","text":"Spinner_text__zzwBL"};